<div *ngIf="errorMessages.length > 0">
  <p-messages severity="error">
    <ng-template pTemplate>
      <span class="p-message-icon pi pi-times-circle"></span>
      <span class="p-ml-2"
        >Please correct the following errors to create the Document.</span
      >
      <ul>
        <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
      </ul>
    </ng-template>
  </p-messages>
</div>
<form [formGroup]="documentForm">
  <div class="general-tab">
    <div class="fields-row">
      <div class="field-title field-required">
        <bpt-text-input
          label="Title"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.title }"
          [disabled]="false"
          id="documentTitle"
          formControlName="title"
          [maxlength]="205"
        ></bpt-text-input>
      </div>
      <div class="field">
        <bpt-text-input
          label="Legacy Document #"
          formControlName="legacyDocument"
          [maxlength]="255"
          id="documentLegacyDocument"
        >
        </bpt-text-input>
      </div>
    </div>
<div class="fields-row">
  <div class="field">
    <bpt-dropdown
    label="Classification Level"
          [options]="documentBindData?.classificationLevel ?? []"
          id="documentClassificationLevel"
          formControlName="classificationLevel"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
    (dropdownChange)="selectedValue($event)"
  >
  </bpt-dropdown>
  </div> 
      <div class="field">
        <bpt-dropdown
          label="Category"
          [options]="documentBindData?.categories ?? []"
          [editable]="false"
          id="documentCategory"
          formControlName="category"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Operational Group"
          [options]="documentBindData?.operationalGroup ?? []"
          [editable]="false"
          id="documentOperationalGroup"
          formControlName="operationalGroup"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
</div>

    <div class="fields-row" *ngIf="isEditSlider">
      <div class="field" *ngIf="!isEffectiveVersionHide">
        <bpt-datetime
          id="documentEffectiveDate"
          [minDate]="minDateValue.toString()"
          label="Effective Date"
          formControlName="effectiveDate"
        ></bpt-datetime>
      </div>
      <div class="field" *ngIf="isRequestedEffectiveDateToBeDisplayed">
        <bpt-datetime
          id="documentRequestedEffectiveDate"
          [minDate]="minDateValue.toString()"
          label="Requested Effective Date"
          formControlName="requestedEffectiveDate"
        ></bpt-datetime>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Periodic Review Cycle"
          [required]="true"
          [options]="documentBindData?.periodicReviewCycles ?? []"
          formControlName="periodicReviewCycle"
          [editable]="false"
          id="documentPeriodicReviewCycle"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          (ngModelChange)="CheckPeriodicReviewCycle()"
          [ngClass]="{ 'error-highlight': mandatoryFields.periodicReviewCycle }"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-datetime
          id="localPeriodicReviewDate"
          [minDate]="minDateValue.toString()"
          label="Periodic Review Date"
          formControlName="periodicReviewDate"
        ></bpt-datetime>
      </div>
    </div>

    <div class="fields-row" *ngIf="!isEditSlider">
      <div class="field field-required">
        <bpt-dropdown
          label="Periodic Review Cycle"
          [required]="true"
          [options]="documentBindData?.periodicReviewCycles ?? []"
          formControlName="periodicReviewCycle"
          [editable]="false"
          id="documentPeriodicReviewCycle"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          (ngModelChange)="CheckPeriodicReviewCycle()"
          [ngClass]="{ 'error-highlight': mandatoryFields.periodicReviewCycle }"
        >
        </bpt-dropdown>
      </div>
      <div class="field"></div>
      <div class="field"></div>
    </div>

    <div class="fields-row">

      <div class="field mt-3">
        <p-checkbox
          p-label-active
          label="Includes QA Review"
          [binary]="true"
          formControlName="includeQAReview"
          (ngModelChange)="ValidateAssignedQAsCheck()"
        >
        </p-checkbox>
        <i
          class="fa fa-info-circle ml-2 info-icon-color"
          aria-hidden="true"
          pTooltip="{{ infoForIncludeQAReview }}"
        ></i>
      </div>
      <div class="field mt-3">
        <p-checkbox
        p-label-active
        label="Includes Client Signature"
        [binary]="true"
        formControlName="includesClientSignature"
        (ngModelChange)="ValidateInternalClientContactsCheck()"
      >
      </p-checkbox>
      <i
        class="fa fa-info-circle ml-2 info-icon-color"
        aria-hidden="true"
        pTooltip="{{ infoForIncludesClientSignature }}"
      ></i>
      </div>
      <div class="field mt-3">
        <p-checkbox
          p-label-active
          label="Convert to PDF"
          [binary]="true"
          formControlName="convertToPdf"
          (ngModelChange)="ValidateConvertToPDFCheck()"
        >
        </p-checkbox>
        <i
          class="fa fa-info-circle ml-2 info-icon-color"
          aria-hidden="true"
          pTooltip="{{ infoForConvertToPdf }}"
        ></i>
      </div>
    </div>
    <div class="fields-row">

      <div class="field mt-3">
        <p-checkbox
          p-label-active
          label="Merge Client Signature Attachment"
          [binary]="true"
          formControlName="mergeClientSignatureAttachment"
         
        >
        </p-checkbox>
        <i
          class="fa fa-info-circle ml-2 info-icon-color"
          aria-hidden="true"
          pTooltip="{{ infoForMergeClientSignatureAttachment }}"
        ></i>
      </div>
      <div class="field mt-3">
      </div>
      <div class="field mt-3">
      </div>
    </div>
    <div class="fields-row">
      <div class="field">
        <bpt-text-input
        formControlName="reason"
        [highlightAllOnFocus]="true"
        [multiLine]="true"
        id="documentReason"
        label="Reason"
      ></bpt-text-input>
      </div>
    </div>

    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Division"
          [required]="true"
          [options]="documentBindData?.divisions ?? []"
          [editable]="false"
          id="documentDivision"
          formControlName="division"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.division }"
        >
        </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Functional Area"
          [required]="true"
          [options]="documentBindData?.functionalAreas ?? []"
          [editable]="false"
          id="documentFunctionalArea"
          formControlName="functionalArea"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.functionalArea }"
        >
        </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Type"
          [required]="true"
          [options]="documentBindData?.documentTypes ?? []"
          id="documentType"
          formControlName="documentType"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.documentType }"
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field">
        <bpt-dropdown
          label="Local Level"
          [options]="documentBindData?.localLevels ?? []"
          id="documentLocalLevel"
          formControlName="localLevel"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Local Category"
          [options]="documentBindData?.localCategories ?? []"
          id="documentLocalCategory"
          formControlName="localCategory"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Local Type"
          [options]="documentBindData?.localTypes ?? []"
          formControlName="localType"
          id="documentLocalType"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Responsible Sub-BU"
          [options]="sbuList ?? []"
          formControlName="responsibleSubBusinessUnit"
          id="documentResponsibleSubBU"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="eQMS Scope(s)"
          [required]="true"
          [options]="eQMSScopeList ?? []"
          id="documenteQMSScope"
          formControlName="eQMSScopes"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [multiSelect]="true"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.eQMSScopes}"
          (valueChange)="validateeQMSScopes()"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Author"
          [required]="true"
          [options]="authorList ?? []"
          formControlName="author"
          id="documentAuthor"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.author}"
        >
        </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Assigned Admin(s)"
          [required]="true"
          [multiSelect]="true"
          [options]="assignedAdminGroupsAndUsersList ?? []"
          formControlName="assignedAdmins"
          id="documentAssignedAdmin"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.assignedAdmins}"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Collaborator(s)"
          [options]="collaboratorGroupsAndUsersList ?? []"
          formControlName="collaborators"
          id="documentCollaborators"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
        label= "Assigned QA(s)"
        [required]="isAssignedQAControlEnabled"
          [options]="assignedQAsGroupsAndUsersList ?? []"
          formControlName="assignedQAs"
          id="documentAssignedQAs"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{'error-highlight': isAssignedQAsMandatory}"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Assigned Doc Control(s)"
          [required]="true"
          [options]="assignedDocControlGroupsAndUsersList ?? []"
          formControlName="assignedDocControl"
          id="documentassignedDocControl"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{'error-highlight': mandatoryFields.assignedDocControl}"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
        <bpt-dropdown
          label="Internal Client Contact(s)"
          [required]="isInternalClientContactControlEnabled"
          [options]="internalClientContactsUsersList ?? []"
          formControlName="internalClientContacts"
          id="documentInternalClientContacts"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{'error-highlight': isInternalClientContactsMandatory}"
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Reviewer(s)"
          [required]="true"
          [options]="reviewersList ?? []"
          formControlName="reviewers"
          id="documentReviewers"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.reviewers }"
          (ngModelChange)="VerifyReviewerAndApprover()"
        >
        </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Approver(s)"
          [required]="true"
          [options]="approversList ?? []"
          formControlName="approvers"
          id="documentApprovers"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.approvers }"
          (ngModelChange)="VerifyReviewerAndApprover()"
        >
        </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Periodic Reviewer(s)"
          [required]="isPeriodicReviewerRequired"
          [options]="periodicReviewersGroupsAndUsersList ?? []"
          formControlName="periodicReviewers"
          id="documentPeriodicReviewers"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{'error-highlight' : isPeriodicReviewerMandatory }"
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field">
        <bpt-dropdown
          label="Tag(s)"
          [options]="documentBindData?.tags ?? []"
          formControlName="tags"
          id="documentTags"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
        >
        </bpt-dropdown>
      </div>
      <div class="field mt-3">
        <p-checkbox
          p-label-active
          label="Forbid changes after Formatting Phase"
          [binary]="true"
          formControlName="forbidChangesAfterInReviewTransition"
        >
        </p-checkbox>
        <i
          class="fa fa-info-circle ml-2 info-icon-color"
          aria-hidden="true"
          pTooltip="{{ infoForForbidChangesAfterInReviewTransition }}"
        ></i>
      </div>
      <div class="field mt-3">
        <p-checkbox
        p-label-active
        label="Print Lock"
        [binary]="true"
        formControlName="printLock"
      >
      </p-checkbox>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Security/Permission(s)"
          [options]="documentBindData?.securities ?? []"
          formControlName="securityPermissions"
          id="documentSecurity"
          [editable]="false"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [required]="true"
          [ngClass]="{ 'error-highlight': mandatoryFields.securityPermissions }"
        >
        </bpt-dropdown>
      </div>

      <div class="field">
        <bpt-dropdown
          label="Confidentiality Level"
          [required]="true"
          [options]="documentBindData?.confidentialityLevels ?? []"
          [editable]="false"
          formControlName="confidentialityLevel"
          id="documentConfidentialityLevel"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields.confidentialityLevel }"
        >
        </bpt-dropdown>
      </div>
      <div class="field">
      </div>
    </div>
  </div>
  <div class="buttons">
    <p-button
    appPreventDoubleClick
    (debounceClick)="updateDocument()"
      *ngIf="isEditSlider"
      label="Save"
      type="submit"
      id="generalDetailsSaveButton"
      class="align-right"
      styleClass="bpt-button-compact"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
    (debounceClick)="openNextTab()"
      label="Next"
      type="submit"
      id="generalDetailsNextButton"
      styleClass="bpt-button-compact"
      class="align-right mr-3"
    >
    </p-button>
  </div>
</form>

<!-- ToDO : Need to Move to common place to use across tabs -->
<p-dialog
  [(visible)]="showDeletedFilesConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteAttachmentConfirmationMessage }}</span>
  </div>
  <ul>
    <li *ngFor="let deleteAttachment of deletedAttachments">
      {{ deleteAttachment.attachmentName }}
    </li>
  </ul>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (debounceClick)="saveDocument()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showDeletedClientSignatureAttachmentConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModalForDeletedClientSignatureAttachments()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteClientSignatureAttachmentConfirmationMessage }}</span>
  </div>
  <ul>
      {{ deletedClientSignatureAttachment?.attachmentName }}
  </ul>
  <ng-template pTemplate="footer">
    <p-button
      label="No"
      type="submit"
      icon="pi pi-times"
      id="deletedFilesConfirmationNoButton"
      styleClass="p-button-outlined"
      class="align-right"
      (onClick)="closeConfirmationModal()"
    >
  </p-button>
    <p-button
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (onClick)="showConfirmationPopupForDeletedClientSignatureAttachments()"
    >
    </p-button>
    
    
  </ng-template>
</p-dialog>

<app-dialog *ngIf="isReasonForDocumentUpdateRequired"
[reasonValidationMessage]="reasonValidationMessage"
[heading]="heading"
(saveDocumentwithReason)="saveDocumentwithReason($event)" 
(isModelOpen)="closeReasonDailog($event)">  
</app-dialog>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField" (confirmed)="saveDocumentwithInactiveAssignmentGroup()" (dialogClosed)="closeConfirmationDailog($event)">
</app-confirmation-dialog>
